import RenderInput from "./RenderInput";
import RenderDatePicker from "./RenderDatePicker";
import RenderTimePicker from "./RenderTimePicker";
import RenderRadio from "./RenderRadio";
import RenderCheckbox from "./RenderCheckbox";
import RenderSelect from "./RenderSelect";
import RenderSubQuestion from "./RenderSubQuestion";

export default function QuestionOptionContent(props) {
	const {
		question = null,
		description = null,
		namePath = [],
		type = null,
		required = false,
		add_another = false,
		form_question_options = [],
	} = props;

	switch (type) {
		case "Text (Input)":
			return (
				<RenderInput
					question={question}
					description={description}
					namePath={namePath}
					required={required}
					add_another={add_another}
					form_question_options={form_question_options}
				/>
			);

		case "Number (Input)":
			return (
				<RenderInput
					question={question}
					description={description}
					namePath={namePath}
					required={required}
					form_question_options={form_question_options}
					inputType="number"
					add_another={add_another}
				/>
			);

		case "Date (Datepicker)":
			return (
				<RenderDatePicker
					question={question}
					description={description}
					namePath={namePath}
					required={required}
					add_another={add_another}
				/>
			);

		case "Time (Timepicker)":
			return (
				<RenderTimePicker
					question={question}
					description={description}
					namePath={namePath}
					required={required}
					add_another={add_another}
				/>
			);

		case "Radio (Button)":
			return (
				<RenderRadio
					question={question}
					description={description}
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
					add_another={add_another}
				/>
			);

		case "Checkbox":
			return (
				<RenderCheckbox
					question={question}
					description={description}
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
					add_another={add_another}
				/>
			);

		case "Select (Dropdown)":
			return (
				<RenderSelect
					question={question}
					description={description}
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
					add_another={add_another}
				/>
			);

		case "sub_question":
			return (
				<RenderSubQuestion
					question={question}
					description={description}
					namePath={namePath}
					form_question_options={form_question_options}
					required={required}
					add_another={add_another}
				/>
			);

		default:
			return null;
	}
}
